var CustomWidgets = {};

(function () {

    async function removeSampleFromCart(pageReload=false,callback,cart=null){
        let checoutBtns = document.getElementsByName('[name="checkout"');
        if(checoutBtns){
            checoutBtns = Array.prototype.slice.call(checoutBtns);
        }
        if(checoutBtns.length > 0){
            checoutBtns.map(checoutBtn => checoutBtn.disabled = true);
        }
        if(typeof cart === 'object' && cart !== null){
            if(cart.items.length === 1){
                let sampleItems = [];
                sampleItems =  cart.items.filter((item,index) => {
                    if(typeof item.properties === 'object' && item.properties !== null ){
                        if(typeof Object.keys(item.properties) !== 'undefined' && Object.keys(item.properties).length > 0){
                            if(item.properties['free_sample']){
                                return Boolean(item.properties['free_sample']) === true;
                            }
                        }
                    }
                });

                if(sampleItems.length > 0){
                    let removeSampleData = {};
                    removeSampleData.updates = {};
                    sampleItems.map((sample) => {
                        removeSampleData.updates[sample.variant_id]=0;
                    });

                    if(Object.keys(removeSampleData).length > 0){
                        await fetch('/cart/update.js',{
                            method:"post",
                            headers:{"Content-Type":"application/json"},
                            body:JSON.stringify(removeSampleData)
                        }).then(function(fetchRes){
                            if (fetchRes.status !== 200 || fetchRes.ok === false) {
                                if(checoutBtns.length > 0){
                                    checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                                }
                                console.log('Looks like there was a problem. Status Code: ' + response.status);
                                return;
                            }
                            return fetchRes.json();
                        }).then(function(json){
                            if(checoutBtns.length > 0){
                                checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                            }
                            if(typeof callback === 'function'){
                                callback();
                            }else if(pageReload === true){
                                location.reload();
                            }
                        }).catch(function(error){
                            if(checoutBtns.length > 0){
                                checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                            }
                            console.log(error);
                        });
                    }
                }else{
                    if(checoutBtns.length > 0){
                        checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                    }
                }
            }else{
                if(checoutBtns.length > 0){
                    checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                }
            }
            return;
        }
        await fetch('/cart.js',{
            method:'GET'
        }).then(function(fetchRes){
            if (fetchRes.status !== 200 || fetchRes.ok === false) {
                if(checoutBtns.length > 0){
                    checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                }
                console.log('Looks like there was a problem. Status Code: ' + response.status);
                return;
            }
            return fetchRes.json();
        }).then(function(json){
            if(json.items.length === 1){
                let sampleItems = [];
                sampleItems =  json.items.filter((item,index) => {
                    if(typeof item.properties === 'object' && item.properties !== null ){
                        if(typeof Object.keys(item.properties) !== 'undefined' && Object.keys(item.properties).length > 0){
                            if(item.properties['free_sample']){
                                return Boolean(item.properties['free_sample']) === true;
                            }
                        }
                    }
                });

                if(sampleItems.length > 0){
                    let removeSampleData = {};
                    removeSampleData.updates = {};
                    sampleItems.map((sample) => {
                        removeSampleData.updates[sample.variant_id]=0;
                    });

                    if(Object.keys(removeSampleData).length > 0){
                        fetch('/cart/update.js',{
                            method:"post",
                            headers:{"Content-Type":"application/json"},
                            body:JSON.stringify(removeSampleData)
                        }).then(function(fetchRes){
                            if (fetchRes.status !== 200 || fetchRes.ok === false) {
                                if(checoutBtns.length > 0){
                                    checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                                }
                                console.log('Looks like there was a problem. Status Code: ' + response.status);
                                return;
                            }
                            return fetchRes.json();
                        }).then(function(json){
                            if(checoutBtns.length > 0){
                                checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                            }
                            if(typeof callback === 'function'){
                                callback();
                            }else if(pageReload === true){
                                location.reload();
                            }
                        }).catch(function(error){
                            if(checoutBtns.length > 0){
                                checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                            }
                            console.log(error);
                        });
                    }
                }else{
                    if(checoutBtns.length > 0){
                        checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
                    }
                }
            }
        }).catch(function(error){
            if(checoutBtns.length > 0){
                checoutBtns.map(checoutBtn => checoutBtn.disabled = false);
            }
            console.log(error);
        });
    }


    function homeSixLabsAccordian(){
        // W3C's JS Code
        var acc = document.getElementsByClassName("accordion");
        var i;

        // Open the first accordion
        // var firstAccordion = acc[0];
        // var firstPanel = firstAccordion.nextElementSibling;
        // firstAccordion.classList.add("active");
        // firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";

        // Add onclick listener to every accordion element
        for (i = 0; i < acc.length; i++) {
            acc[i].onclick = function() {
            // For toggling purposes detect if the clicked section is already "active"
            var isActive = this.classList.contains("active");

            // Close all accordions
            var allAccordions = document.getElementsByClassName("accordion");
            for (j = 0; j < allAccordions.length; j++) {
                // Remove active class from section header
                allAccordions[j].classList.remove("active");

                // Remove the max-height class from the panel to close it
                var panel = allAccordions[j].nextElementSibling;
                var maxHeightValue = getStyle(panel, "maxHeight");

            if (maxHeightValue !== "0px") {
                    panel.style.maxHeight = null;
                }
            }

            // Toggle the clicked section using a ternary operator
            isActive ? this.classList.remove("active") : this.classList.add("active");

            // Toggle the panel element
            var panel = this.nextElementSibling;
            var maxHeightValue = getStyle(panel, "maxHeight");

                if (maxHeightValue !== "0px") {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            };
        }

        // Cross-browser way to get the computed height of a certain element. Credit to @CMS on StackOverflow (http://stackoverflow.com/a/2531934/7926565)
        function getStyle(el, styleProp) {
            var value, defaultView = (el.ownerDocument || document).defaultView;
            // W3C standard way:
            if (defaultView && defaultView.getComputedStyle) {
                // sanitize property name to css notation
                // (hypen separated words eg. font-Size)
                styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
                return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
            } else if (el.currentStyle) { // IE
                // sanitize property name to camelCase
                styleProp = styleProp.replace(/\-(\w)/g, function(str, letter) {
                return letter.toUpperCase();
                });
                value = el.currentStyle[styleProp];
                // convert other units to pixels on IE
                if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
                return (function(value) {
                    var oldLeft = el.style.left, oldRsLeft = el.runtimeStyle.left;
                    el.runtimeStyle.left = el.currentStyle.left;
                    el.style.left = value || 0;
                    value = el.style.pixelLeft + "px";
                    el.style.left = oldLeft;
                    el.runtimeStyle.left = oldRsLeft;
                    return value;
                })(value);
                }
                return value;
            }
        }
    }

    function homeSixLabsSlideModule() {
        var $container = $('.sliding-module-wrapper');
        if ($container.length > 0) {
          var $slidesImages = $container.find('.sliding-module-slider');

          $slidesImages.slick({
              infinite: true,
              dots: false,
              slidesToShow: 1,
              draggable: false,
              arrows: false,
              swipe: false,
              adaptiveHeight: true,
              responsive: [{
                  breakpoint: 500,
                  settings: {
                      arrows: true,
                      dots: true,
                      swipe: true,
                      draggable: true,
                      prevArrow: '<div class="slick-prev"></div>',
                      nextArrow: '<div class="slick-next"></div>'
                  }
              }]
          });

          $('.links span.next').on('click', function(){
              $slidesImages.slick('slickNext');
          });

          $('.links span.prev').on('click', function(){
              $slidesImages.slick('slickPrev');
          });

          $('.module-image .circle-box').on('click', function(){
              $slidesImages.slick('slickGoTo', $(this).data('id'));
          });
        }
    }

    function pdpFullCircleModule() {
      var $container = $('#pdp-fullcircle-content');

      if ($container.length > 0) {
          var $tabs = $container.find('span.lab__title');
          var $tabContents = $container.find('.full_circle_tab');

          $tabs.on('click', function(){
              $tabs.removeClass('active');
              $(this).addClass('active');

              $tabContents.removeClass('active');
              $container.find('.full_circle_tab[data-id=' + $(this).data('id') + ']').addClass('active');
          });
      }
  }

  function pdpInitModule() {
      var $container = $('.product-form--submit .quantity-wrapper');

      if ($container.length > 0) {
          $('body').on('click', '.product-form--submit .quantity-wrapper .plus:not(.disabled)', function(){
              var quantity = $container.find('span').text();
              quantity = parseInt(quantity) + 1;

              $(this).closest('.quantity-wrapper').find('.minus').removeClass('disabled');
              $('input[name=quantity]').val(quantity);
              $container.find('span').text((quantity < 10 ? '0' : '' ) + quantity);
          });

          $('body').on('click', '.product-form--submit .quantity-wrapper .minus:not(.disabled)', function(){
              var quantity = $container.find('span').text();
              quantity = parseInt(quantity) - 1;

              if (quantity <= 1) {
                  quantity = 1;
                  $(this).addClass('disabled');
              }

              $('input[name=quantity]').val(quantity);
              $container.find('span').text((quantity < 10 ? '0' : '' ) + quantity);
          });
      }
  }

  function init() {
      // assign function
      CustomWidgets.removeSampleFromCart = removeSampleFromCart;
      CustomWidgets.removeSampleFromCart(true);
      homeSixLabsAccordian();

      homeSixLabsSlideModule();
      pdpFullCircleModule();
      pdpInitModule();
  }
  init();
})(CustomWidgets);


// jQuery('#create_customer').submit(function(event) {
//     snaptr('track', 'SIGN_UP');
// });

var $cForm      = $('#create_customer');
var $cFormBtn   = $('#create_customer .primary-btn');

console.log('$cForm', $cForm);
console.log('$cFormBtn', $cFormBtn);

$cFormBtn.on('click', function(event){
  event.preventDefault();
  $form = $cForm

  $.ajax({
    url: $form.attr('action'),
    type: 'POST',
    data: $form.serialize()
  })
  .done(function (data) {
    let errors = $(data).find('.js-error').html();
    let recaptcha = $(data).find('#g-recaptcha');
    if (errors) {
      const $errorElement = $cForm.find('.js-error');
      if ($errorElement.length) {
        if (errors.includes('<a href="/account/login#recover">')) {
          errors = errors.replace('<a href="/account/login#recover">', '<a href="/account/login#recover" class="forgot-pwd">');
        }
        $errorElement.html(errors);
        $errorElement.removeClass('hidden');
      }
    } else if (recaptcha) {
      sessionStorage.setItem('account-registration', true);
      location = location.origin + '/challenge#create_customer';
    } else {
      window.location="/account";
    }
  })
  .fail(function (jqXHR, textStatus, errorThrown) {
    console.log('Fail', errorThrown);
    console.log('Fail', textStatus);
    console.log('Fail', jqXHR);
  });
});

if (location.pathname === '/account/register') {
  sessionStorage.removeItem('account-registration');
}

window.addEventListener('DOMContentLoaded', (event) => {
  $('.js-checkout-btn').on('click', function(event) {
    if (event.originalEvent) {
      event.preventDefault();
  
      fetch('/cart.js')
        .then(response => response.json())
        .then(response => {
          let onlyFreeSamples = response.items.length > 0 ? true : false;
  
          for (const line_item of response.items) {
            if (line_item.product_type === 'Sample') {
              onlyFreeSamples = true;
            } else {
              onlyFreeSamples = false;
              break;
            }
          }
  
          if (onlyFreeSamples) {
            location.href = location.href;
          } else {
            $(this).trigger('click');
          }
        })
    }
  })
});
